import React from "react";
import { MapContainer, TileLayer, Marker, Polyline, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const VehicleTracker = ({ route }) => {
  if (!route || route.length === 0) {
    return <p className="text-gray-400">No route data available</p>;
  }

  const center = route[0];

  return (
    <MapContainer center={[center.lat, center.lng]} zoom={14} style={{ height: "400px", width: "100%" }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://osm.org/copyright">OSM</a>'
      />
      <Polyline positions={route.map((p) => [p.lat, p.lng])} color="blue" />
      {route.map((point, idx) => (
        <Marker key={idx} position={[point.lat, point.lng]}>
          <Popup>Lat: {point.lat}, Lng: {point.lng}</Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default VehicleTracker;
